<template>
  <article>
    <section class="xbed-sub-title">
      <span>{{title}}</span>
    </section>

    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>首页</BreadcrumbItem>
        <BreadcrumbItem>广告设计</BreadcrumbItem>
        <BreadcrumbItem>{{title}}</BreadcrumbItem>
      </Breadcrumb>
    </section>
    <section class="news-info">
      <Row>
        <Col span="14">
          <Form :model="article" ref="articleForm" :rules="ruleValidate" label-position="left" :label-width="120">
            <FormItem label="文章标题：" prop="title">
              <Input v-model="article.title" placeholder="限定50字符以内"></Input>
            </FormItem>

            <FormItem prop="SEOtags" label="SEO标签：">
              <Input :maxlength="100" v-model="article.SEOtags"></Input>
              <Alert style="margin-top: 4px;" type="warning" show-icon>说明：keywords，如有多个标签请使用英文逗号“,”隔开</Alert>
            </FormItem>

            <FormItem label="状态：">
              <RadioGroup v-model="article.status">
                <Radio v-bind:label='0'>关闭</Radio>
                <Radio v-bind:label='1'>开启</Radio>
              </RadioGroup>
            </FormItem>

            <FormItem label="文章类型：">
              <Select v-model="article.type" style="width:200px;" @on-change="clearTermAndColumn" placeholder="请选择">
                <Option v-for="articleType in typeList" :key="articleType.typeId" :value="articleType.typeId">{{articleType.typeName}}</Option>
              </Select>
            </FormItem>

            <FormItem v-if="terminalList[article.type]" label="显示终端：">
              <CheckboxGroup v-model="article.terminal">
                <span v-for="terminal in terminalList[article.type]" :key="terminal.terminalId" v-if="terminal.type === article.type">
                  <Checkbox :label="terminal.terminalId">
                    <span>{{terminal.terminalName}}</span>
                  </Checkbox>
                  <Select v-model="article.column" v-if="columnList[article.type] && columnList[article.type].length > 0" style="width:200px;" placeholder="请选择">
                    <Option v-for="column in columnList[article.type]" v-if="column.type === article.type" :key="column.columnId" :value="column.columnId">{{column.columnName}}</Option>
                  </Select>
                </span>
              </CheckboxGroup>
            </FormItem>

            <FormItem v-if="article.type==2 || article.type==6 || article.type==7" label="城市：" prop="cityTags">
              <Tag v-for="tag in cityTags" :key="tag.cityId" :name="tag.cityId" @on-close="(e, cityId) => {removeCityTag(cityId)}" closable color="primary">{{tag.city}}</Tag>
              <Cascader :data="citiesData" ref="cityPicker" @on-change="(value, selectedData)=>{addCityTag(selectedData[1])}" style="width: 250px;margin-top: 10px;" :clearable="false" ></Cascader>
            </FormItem>

            <FormItem label="文章来源：">
              <RadioGroup v-model="article.source">
                <Radio v-bind:label='1'>原创</Radio>
                <Radio v-bind:label='2'>转载</Radio>
              </RadioGroup>
            </FormItem>

            <FormItem v-if="article.source==2" prop="reprintUrl" >
              <Input v-model="article.reprintUrl" placeholder="转载链接"></Input>
            </FormItem>

            <FormItem label="权重值：">
              <InputNumber :max="500" :min="0" v-model="article.sortNum"></InputNumber>
            </FormItem>

            <FormItem label="文章摘要：" prop="summary">
              <Input v-model="article.summary" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="限定100字符以内"></Input>
            </FormItem>
          </Form>

        </Col>

        <Col span="5" offset="2">
          <div class="upload-wrapper">
            <div style="text-align: center;">
              <img style="height:180px" :src="article.coverPicPath" alt="">
            </div>
            <Upload type="drag" action="//upload.qiniup.com" name="file" :data="uploadData" :before-upload="beforeUpload" :on-success="uploadSuccess" v-bind:show-upload-list="false">
              <div style="padding: 20px 10px">
                <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                <p>点击或将图片拖拽到这里上传、修改封面图</p>
                <p style="color:red">注：建议尺寸为320*180px</p>
              </div>
            </Upload>
          </div>
        </Col>
      </Row>
    </section>

    <section class="news-editor">
      <tinymce ref="articleEditor" id="articleEditor" :other_config="editor_other_config" v-model="article.content" ></tinymce>
    </section>

    <Button style="margin-top:20px" type="success" :loading="submitting" @click="submitArticle" long>
      <span v-if="!submitting">保存</span>
      <span v-else>提交中</span>
    </Button>

  </article>
</template>

<script>
import Utils from "../../utils";
import API from "../../api";

export default {
  async created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
    // 获取文章ID，如果没有ID表示新增文章
    this.atricleId = Utils.getUrlParameterByName("atricleId");
  },
  async mounted() {
    this.$Notice.config({
      top: 100
    });

    // 查询文章列表页下拉列表
    const selectiveResp = (await API.omsAPI[this.env].advert.getArticleSelective({}, this.token)).data;

    if (selectiveResp.retCode) {
      this.$Notice.error({
        title: "查询文章列表页下拉列表失败",
        desc: selectiveResp.msg
      });
    }

    this.initSelective(selectiveResp);

    if (this.atricleId) {
      const resp = (await this.queryAtricle(this.atricleId)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "查询文章失败",
          desc: resp.msg
        });
      }

      this.initEditArticle(resp);

    } else {
      this.article.createName = this.username;
    }

    // 城市数据
    const citiesResp = (await API.omsAPI[this.env].advert.queryAllCities(this.token)).data;

    if (citiesResp.retCode) {
      this.$Notice.error({
        title: "获取城市数据失败",
        desc: citiesResp.msg
      });
    }

    let allCities = citiesResp

    this.initCitiesData(allCities);

    this.$nextTick(() => {
      this.$refs.articleEditor.init();
    });
  },
  data() {
    const validateCityTags = (rule, value, callback) => {
      if (this.cityTags.length === 0) {
        callback(new Error('请选择城市'));
      } else {
        callback();
      }
    };

    // 引用API包，编辑器上传图片配置用
    const apiModule = API;

    return {
      originData: {
        type: 1,
        terminal: [],
        column: ''
      }, // 初始数据
      columnList: {},
      terminalList: {},
      typeList: [],
      id: "",
      // article: {
      //   content: '<p>图片</p>\n<p><video controls=\"controls\" width=\"300\" height=\"150\">\n<source src=\"http://www.xbed.com.cn/video/01.mp4\" type=\"video/mp4\" /></video></p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>'
      // },
      // 编辑器上传图片配置
      editor_other_config: {
        getUploadToken: async () => {
          const token = (await apiModule.omsAPI[this.env].common.getUploadToken(false, this.token)).data
          return token
        }
      },
      citiesData: [],
      cityTags: [],
      article: {
        column: 1,
        content: "",
        coverPicPath: "",
        reprintUrl: "",
        source: 1,
        status: 1,
        summary: "",
        terminal: [],
        title: "",
        sortNum: 1,
        SEOtags: '',
        type: 1
      },
      ruleValidate: {
        title: [
          { required: true, message: "文章标题不能为空", trigger: "blur" },
          { type: "string", max: 50, message: "文章标题不能超过50字" }
        ],
        summary: [
          { required: true, message: "文章摘要不能为空", trigger: "blur" },
          { type: "string", max: 100, message: "文章摘要不能超过100字" }
        ],
        reprintUrl: [
          { required: true, message: "转载链接不能为空", trigger: "blur" },
          { pattern:"[a-zA-z]+://[^\s]*",message:"请输入正确的转载链接",trigger: "blur" },
          { type: "string", max: 2000 ,message:"转载链接不能超过2000字",trigger: "blur" }
        ],
        cityTags: [
          { validator: validateCityTags }
        ],
        SEOtags: [
          { required: false, trigger: "blur" },
          { type: "string", max: 100, message: "SEO标签不能超过100字" }
        ]
      },
      uploadData: {},
      submitting: false,
    };
  },
  methods: {
    initSelective(selectiveResp) {
      this.typeList = selectiveResp.type;
      // 终端
      selectiveResp.terminals.map(terminal => {
        let type = terminal.type
        if (this.terminalList[type]) {
          this.terminalList[type].push(terminal)
        } else {
          this.terminalList[type] = [terminal]
        }
      })

      // 栏目
      selectiveResp.columns.map((column) => {
        let type = column.type
        if (this.columnList[type]) {
          this.columnList[type].push(column)
        } else {
          this.columnList[type] = [column]
        }
      })
    },
    initCitiesData(allCities=[]) {
      allCities.map(city => {
        let finishedPush = false; 
        let cityData = { label: city.name, value: city.id };
        this.citiesData.map(item => {
          if (item.value==city.province) {
            item.children.push(cityData)
            finishedPush = true;
          }
        })
        if (!finishedPush) {
          this.citiesData.push({ value: city.province, label: city.province, children: [cityData] })
        }
      })
    },
    queryAtricle(atricleId) {
      return API.omsAPI[this.env].advert.getArticleDetails(atricleId);
    },
    initEditArticle(detail) {

      // 显示终端
      if (detail.terminal) {
        const terminalArr = detail.terminal.split(',');
        detail.terminal = [];
        for (let i=0; i<terminalArr.length; i++) {
          let terminal = +terminalArr[i]
          detail.terminal.push(terminal);
        }
      } else {
        detail.terminal = [];
      }

      this.originData = {
        type: detail.type,
        terminal: detail.terminal,
        column: detail.column
      }

      this.article = Object.assign({}, this.article, detail);

      this.$refs.articleEditor.setContent(this.article.content);

      // 生成城市tag
      if (this.article.type==2 || this.article.type==6 || this.article.type==7 ) {
        // 过滤没有城市的
        if (!this.article.city || this.article.city.length === 0) {
          return
        }
        let city = this.article.city.split(',');
        this.article.cityId.split(',').map((cityId,index)=>{
          this.cityTags.push({ city: city[index], cityId: cityId });
        })
      }
    },
    // 图片上传操作
    async beforeUpload(file) {
      console.info(`${file}`);
      let token = (await API.omsAPI[this.env].common.getUploadToken(false, this.token))
        .data;
      this.uploadData.token = token;
      // this.uploadData.name = `${(Date.now() / 1000) | 0}_${file.name}`;
      this.uploadData["x:fileDirId"] = 636;
      this.uploadData["x:isPrivate"] = 0;
      this.uploadData["x:remark"] = "新增广告图";
      return true;
    },
    uploadSuccess(resp) {
      this.article.coverPicPath = resp.materialBase.url;
    },
    addCityTag(selectedCity) {
      if (this.cityTags.length==8) {
        this.$Notice.error({
          title: "最多只能选择8个城市喔"
        });
        return;
      }
      for (let i=0; i<this.cityTags.length; i++) {
        let cityTag = this.cityTags[i];
        if (cityTag.cityId==selectedCity.value) {
          return;
        }
      }
      this.cityTags.push({ city: selectedCity.label, cityId: selectedCity.value });
    },
    // 移除城市标签
    removeCityTag(cityId) {
      let delIndex = -1;
      for (let i=0; i<this.cityTags.length; i++) {
        let cityTag = this.cityTags[i];
        if (cityTag.cityId==cityId) {
          delIndex = i;
          break;
        }
      }
      this.cityTags.splice(delIndex, 1);
    },
    // 生成城市标签参数
    getTagsParams() {
      if (this.article.type!==2 && this.article.type!==6 && this.article.type!==7) {
        return { city: "", cityId: "" };
      }
      let city = [], cityId = []
      this.cityTags.map(tag => {
        city.push(tag.city);
        cityId.push(tag.cityId);
      })
      return { city: city.toString(), cityId: cityId.toString() }
    },
    // 确认提交
    async submitArticle() {
      let validResult = false;
      this.$refs.articleForm.validate(valid => {
        validResult = valid
      });
      if (!validResult) {
        return;
      }

      // 判断是否有上传图片
      if (!this.article.coverPicPath) {
        this.$Notice.error({
          title: "请上传封面图"
        });
        return;
      }

      // 判断是否提交中
      if (this.submitting) {
        return;
      }

      if (this.terminalList[this.article.type] && this.article.terminal.length === 0) {
        this.$Notice.error({
          title: "请选择显示终端"
        });
        return;
      }

      if (this.columnList[this.article.type] && this.columnList[this.article.type].length > 0 && !this.article.column ) {
        this.$Notice.error({
          title: "请选择项目"
        });
        return;
      }

      if (this.article.content.length === 0) {
        this.$Notice.error({
          title: "请填写文章内容"
        });
        return;
      }

      this.submitting = true;
      if (this.article.articleId) {
        // 修改
        let params = {
          articleId: this.article.articleId,
          column: this.article.column,
          content: this.article.content,
          coverPicPath: this.article.coverPicPath,
          reprintUrl: this.article.reprintUrl,
          source: this.article.source,
          status: this.article.status,
          summary: this.article.summary,
          terminal: this.article.terminal.join(','),
          updateName: this.username,
          title: this.article.title,
          sortNum: this.article.sortNum,
          city: this.getTagsParams().city,
          cityId: this.getTagsParams().cityId,
          type: this.article.type,
          SEOtags: this.article.SEOtags,
        };
        params = Utils.deleteEmptyProperty(params);
        let resp = (await API.omsAPI[this.env].advert.editArticle(params, this.token)).data;

        if (resp.retCode) {
          // 错误警告
          this.$Notice.error({
            title: "修改文章失败",
            desc: resp.msg
          });
        } else {
          this.$Notice.success({
            title: "修改文章成功"
          });
          // this.goBackListPage()
        }
      } else {
        // 新建
        let params = Utils.deleteEmptyProperty(Object.assign(this.article, {city: this.getTagsParams().city, cityId: this.getTagsParams().cityId}));
        let resp = (await API.omsAPI[this.env].advert.addArticle(
          params,
          this.token
        )).data;
        console.info(resp);
        if (resp.retCode) {
          // 错误警告
          this.$Notice.error({
            title: "新建文章失败",
            desc: resp.msg
          });
        } else {
          this.$Notice.success({
            title: "新建文章成功"
          });
          this.refreshPage(resp.articleId)
        }
      }
      this.submitting = false;
    },
    clearTermAndColumn(type) {
      console.info(this.originData);
      if (type === this.originData.type) {
        this.article.terminal = this.originData.terminal;
        this.article.column = this.originData.column;
      } else {
        this.article.terminal = [];
        this.article.column = '';
      }
    },
    refreshPage(articleId) {
      if (this.$router) {
        // 新OMS跳转
        window.location.href = `#/app/advert/articleEdit?atricleId=${articleId}`;
      } else {
        // 旧OMS跳转
        window.location.href = `#/Advert/Advert/articleEdit?atricleId=${articleId}`;
      }
      window.location.reload();
    }
  },
  computed: {
    title() {
      return this.atricleId ? "修改文章" : "新建文章";
    }
  }
};
</script>

<style lang="scss">
.news-info {
  margin-top: 20px;

  .upload-wrapper {
    $uploadWrapperHeight: 300px;

    height: $uploadWrapperHeight;
    .upload-tips {
      height: $uploadWrapperHeight;
      padding: 100px 0;
    }
  }
}

.news-editor {
  margin-top: 20px;
  div.mce-fullscreen {
    z-index: 2000;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/advert/article-edit.vue